// extracted by mini-css-extract-plugin
module.exports = {"error":"styles_error__1u3qB","illustration":"styles_illustration__1TbAF","desc":"styles_desc__2H170","detail":"styles_detail__24jfh"};